import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

import useApiQuery from '../../../../../Hooks/useApiQuery';
import queriesConfig from '../../../../../Services/queriesConfig';
import { Post } from '../../../../../Utils/Types/Posts';
import { singletonQuestionTypes } from '../../../../../Utils/Types/FormBuilder';
import AnswerShow from './AnswerShow';
import { get } from 'lodash';

interface ContributionFormAnswersProps {
  post?: Post;
  hideConfidentialFields?: boolean;
}

export default function ContributionFormAnswers({
  post,
  hideConfidentialFields = false,
}: ContributionFormAnswersProps) {
  const { data: response = {} as any, isLoading } = useApiQuery({
    query: queriesConfig.getFormResponse(post?.id, post?.meta?.user_form_submission_id || 0),
  });
  const answersToRender = response?.answers?.filter(
    (answer: any) => !singletonQuestionTypes.includes(answer?.question?.field_type),
  );

  if (isLoading || !answersToRender) {
    return null;
  }

  return (
    <Stack spacing={3} sx={{ mb: 3 }}>
      {answersToRender?.map((answer: any) => {
        if (!answer.filled_in) {
          return null;
        }

        if (hideConfidentialFields && answer.question.confidential) {
          // Confidential fields are only returned to the admins and the owner of the post
          // but we still don't want to show them in the public post details to avoid any confusion
          return null;
        }

        return (
          <Box key={answer.id}>
            <Typography
              variant="h6"
              component="h2"
              gutterBottom
              sx={{
                fontWeight: 'bold',
                mb: 2,
              }}
            >
              {answer.question.title}
            </Typography>

            <AnswerShow
              answer={answer}
              showPreview
              geojson={get(post, 'included.source.geojson')}
            />
          </Box>
        );
      })}
    </Stack>
  );
}
